export type StepStructure = {
  title: string;
  description: string;
};

export const STEPS_LIST: StepStructure[] = [
  {
    title: 'Заявка',
    description:
      'Отправьте заявку, мы\u00A0перезвоним и\u00A0проконсультируем, а\u00A0также договоримся о\u00A0выезде для замера.',
  },
  {
    title: 'Замер',
    description: 'Вместе со\u00A0специалистом подберём нужное решение и\u00A0составим техническое задание.',
  },
  {
    title: 'Проект',
    description:
      'Сделаем расчёты и\u00A0подготовим проект с\u00A0чертежами, списком материалов и\u00A0ценами. Составим смету на\u00A0работы.',
  },
  {
    title: 'Монтаж',
    description:
      'Опытные специалисты установят систему у\u00A0вас дома под ключ, настроят и\u00A0протестируют оборудование.',
  },
];
